





























































































































import { Component, Ref, Vue, Emit } from 'vue-property-decorator';
import pages from '@/components/page/page.vue';
import drawer from './Drawer.vue';
import { foritem } from './index';
import { associationPage, associationTerminated, associationGet } from '@/utils/supplier';
@Component({
  components: { pages, drawer },
})
export default class DictListView extends Vue {
  @Ref('cooperationStatus') cooperationStatus;
  @Ref('dawer') dawer;
  form: foritem = {
    partnerCode: '',
    partnerName: '',
    partnerCompanyName: '',
    cooperationStatus: null,
    modifiedDate: '',
  };
  pagination: Object = {
    total: 0,
    currentPage: 0,
    pageSize: 10,
  };
  formOptions: any = [
    {
      prop: 'code',
      label: '供应商编号',
      element: 'el-input',
      placeholder: '请输入',
      rules: [{ required: false, message: '必填项', trigger: 'blur' }],
    },
    {
      prop: 'name',
      label: '供应商名称',
      element: 'el-input',
      placeholder: '请输入',
      rules: [{ required: false, message: '必填项', trigger: 'blur' }],
    },
    {
      prop: 'companyName',
      label: '企业名称',
      element: 'el-input',
      placeholder: '请输入',
      rules: [{ required: false, message: '必填项', trigger: 'blur' }],
    },
    {
      prop: 'supplierType',
      label: '供应类型',
      element: 'el-select',
      options: [
        {
          value: '1',
          label: '伙伴自营',
        },
        {
          value: '2',
          label: '平台供应商',
        },
        {
          value: '3',
          label: '伙伴供应商',
        },
      ],
      placeholder: '请输入',
      rules: [{ required: false, message: '必填项', trigger: 'blur' }],
    },
    {
      prop: 'status',
      label: '状态',
      element: 'el-select',
      options: [
        {
          value: 'VALID',
          label: '启用',
        },
        {
          value: 'INVALID',
          label: '停用',
        },
      ],
      placeholder: '请输入',
      rules: [{ required: false, message: '必填项', trigger: 'blur' }],
    },
    {
      prop: 'createdDate',
      label: '创建日期',
      element: 'el-date-picker',
      placeholder: '请输入',
      rules: [{ required: false, message: '必填项', trigger: 'blur' }],
    },
  ];
   btnItems: String = 'search,reset';
  loading: boolean = true;
  tableData: any = [];
  pageNumber: number = 0;
  pageSize: number = 10;
  total: number = 0;
  code: string = '';
  detils: object = {};
  seachenter(e) {
    var key = window.event ? e.keyCode : e.which;
    if (key == 13) {
      this.onSubmit('init');
    }
  }
  hide(val) {
    if (val) {
    } else {
      this.cooperationStatus.blur();
    }
  }
  // 查询
  onSearch(val) {
    // console.log(val, '------------------------123123----------------------');
    this.form = val;
    this.onSubmit('init');
  }
  // 重置
  onReset() {}
  // enter事件
  keydow() {
    document.onkeydown = (e) => {
      let key = document.getElementsByTagName('body')[0];
      if (e.keyCode == 13 && e.target == key && this.$route.path == '/maintain/administer/management') {
        this.onSubmit('init');
      }
    };
  }
  mounted() {
    this.onSubmit('init');
    this.keydow();
  }
  queryArticle() {
    console.log(this.pagination);
    this.onSubmit('init');
  }
  // 详情
  handleClick(val, code) {
    this.dawer.drawer = true;
    var obj = {
      id: val.id,
    };
    associationGet(obj).then((res) => {
      console.log(res);
      this.detils = res;
      this.code = code;
      this.dawer.init(res, code);
    });
  }
  seachevent(e) {
    var key = window.event ? e.keyCode : e.which;
    if (key == 13) {
      this.onSubmit('init');
    }
  }
  //
  // handleEdit(val, code) {
  //   this.dawer.init(val, code);
  // }
  // 分页
  handleSizeChange(page, size) {
    this.pageNumber = page;
    this.pageSize = size;
    this.onSubmit('query');
  }
  //  终止合作
  termination(val) {
    associationTerminated(val).then((res) => {
      this.$message.success('已终止合作');
      this.onSubmit('init');
    });
  }
  // 查询
  onSubmit(val) {
    this.loading = true;
    var obj = {
      pageNumber: val == 'init' ? 0 : this.pagination['currentPage'] - 1,
      pageSize: val == 'init' ? 10 : this.pagination['pageSize'],
      ...this.form,
    };
    associationPage(obj).then((res) => {
      if (res['content']) {
        this.tableData = res['content'];
        this.pagination['total'] = res['totalElements'];
        this.loading = false;
        // this.$message.success('查询完成');
      }
    });
  }
  // 重置
  reset() {
    this.form = {
      partnerCode: '',
      partnerName: '',
      partnerCompanyName: '',
      cooperationStatus: null,
      modifiedDate: '',
    };
    this.onSubmit('init');
  }
}
